import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

export const StyledChooseLocation = Box.withConfig({
  flexDirection: 'row',
  justifySelf: 'flex-end',
  marginLeft: '2',
  fontSize: {
    base: 'sm',
    md: 'md',
  },
  _text: {
    color: primitive.$bbqBrown,
  },
  marginRight: {
    md: '4',
  },
});

interface ChooseLocationType {
  testID?: string;
}

const ArrowRightIcon = Icon.withConfig({
  variant: 'back',
  size: {
    base: 'xs',
    md: 'sm',
  },
  mt: {
    base: '$1',
    md: '$0',
  },
  style: {
    transform: [{ rotate: '180deg' }],
  },
});

const ChooseLocation = ({ testID }: ChooseLocationType) => {
  const chooseYourLocation = t('chooseYourLocation');

  return (
    <StyledChooseLocation
      testID={testID}
      accessibilityLabel={chooseYourLocation}
      accessibilityHint={t('clickToSelectLocation')}
      paddingTop={'$1'}
    >
      {chooseYourLocation}
      <ArrowRightIcon />
    </StyledChooseLocation>
  );
};

export default ChooseLocation;
